import { createAsyncThunk } from "@reduxjs/toolkit";
import { Api } from "../..";
import { API_POST_AGENT_CUSTOMER_METRICS } from "../../Apis/ApiEndPoints";
import { CustomAction } from "../../store/customAction";

export interface IPostMatricsRequestParams {
  customerId: string | undefined;
  carrier: string;
  system: string;
  policiesLimit: string;
}

export const PostCustomerMetrics = createAsyncThunk(
  "agent/PostCustomerMetrics",
  async (requestParams: IPostMatricsRequestParams, { dispatch }) => {
    const response = await CustomAction(
      Api.post(API_POST_AGENT_CUSTOMER_METRICS, requestParams),
      dispatch,
      "agent/PostCustomerMetrics"
    );
    return response;
  }
);
